<template>
	<router-link :to="{ name: 'WatchDashboard', params: { user_uid: user_uid, watch_id: watch.id } }" class="watch">
		<spinner v-if="loading.appointment || loading.birthday" class="spinner"/>
		<avatar-picture-virtual-watch :watch_id="watch.id"/>
		<div class="info">
			<h1>{{ watch.profile_name }}</h1>
			<div v-if="appointment" class="appointment">
				<svgicon name="sethoscope" :fill="false"></svgicon>
				<div>
					<div>{{ $t('base.general.next_appointment') }}</div>
					<div class="date">{{ date }}</div>
				</div>
			</div>
			<div v-if="birthday" class="birthday">
				<svgicon name="birthday" :fill="false"></svgicon>
				<div>
					<div>{{ $t('base.general.next_birthday') }}</div>
					<div class="date">{{ nextBirthday }}</div>
				</div>
			</div>
		</div>
	</router-link>
</template>

<script>
import '@/utils/numberpad'
export default {
	props: [
		'user_uid',
		'watch'
	],
	data () {
		return {
			loading: {
				appointment: false
			},
			appointment: null
		}
	},
	computed: {
		date () {
			return this.appointment ? this.$moment(this.appointment.date_hour).format('D MMM') : null
		},
		birthday () {
			return (this.watch.profile && this.watch.profile.data) ? this.watch.profile.data.birthday : ''
		},
		nextBirthday () {
			if (this.birthday) {
				var year = this.$moment().get('year')
				var month = (this.$moment(this.birthday).get('month') + 1).pad(2)
				var day = this.$moment(this.birthday).get('date').pad(2)
				var next_birthday = this.$moment(`${year}-${month}-${day}`).format('YYYY-MM-DD')
				if (this.$moment().diff(next_birthday) > 0) {
					next_birthday = this.$moment(`${year + 1}-${month}-${day}`).format('YYYY-MM-DD')
				}
				return this.$moment(next_birthday).format('DD MMM')
			}
			return ''
		}
	},
	methods: {
		getAppointment () {
			this.loading.appointment = true
			this.$api.appointments.getAll(this, this.user_uid, this.watch.id, 1).then(response => {
				this.$log.info('dashboard watch', 'appointments.getNext OK', response)()
				if (response.body.length) {
					this.appointment = response.body[0]
				}
			}).catch(errors => {
				this.$log.error('dashboard watch', 'appointments.getNext ERROR', errors)()
			}).finally(() => {
				this.loading.appointment = false
			})
		}
	},
	mounted () {
		this.getAppointment()
	}
}
</script>



// WEBPACK FOOTER //
// src/components/widgets/components/WatchesWidgetWatch.vue